var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.654,
    height: 183.879,
    viewBox: "0 0 122.654 183.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e7f7fd;opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-858.423 -246.694) rotate(-8)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(841 481)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(815 369)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.b170a6d1.svg";
export { ForwardRef as ReactComponent };